import { render, staticRenderFns } from "./CancelarDeduccion.vue?vue&type=template&id=376dad4b"
import script from "./CancelarDeduccion.vue?vue&type=script&lang=js"
export * from "./CancelarDeduccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports